export default __webpack_public_path__ + "static/media/diverse02-3x.560395f1.png";